import { render, staticRenderFns } from "./AvatarEdit.vue?vue&type=template&id=5d10308b&scoped=true&"
import script from "./AvatarEdit.vue?vue&type=script&lang=ts&"
export * from "./AvatarEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarEdit.vue?vue&type=style&index=0&id=5d10308b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10308b",
  null
  
)

export default component.exports